import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  addButton: {
    border: '2px solid var(--primary-text-color)',
    marginLeft: '1rem',
    color: 'var(--primary-text-color)',
  },
}));
